import { Box, ButtonBase } from "@mui/material";
import { green, grey, red } from "@mui/material/colors";
import { useFormikContext } from "formik";
import { Direction, direction } from "../../lazertrader/types";
import { DIRECTION_TOGGLE_WIDTH, SMALL_INPUT_HEIGHT } from "./constants";

const activeColor = (content: Direction) =>
  content === Direction.BUY ? green[600] : red[400];

const SIDES = [Direction.BUY, Direction.SELL];

const BuySellToggle = (props: { disabled?: boolean }) => {
  const { values, setFieldValue } = useFormikContext<{
    direction: Direction;
  }>();

  const current = direction(values.direction);
  const other = current === Direction.BUY ? Direction.SELL : Direction.BUY;
  const isBuy = current === Direction.BUY;

  return (
    <ButtonBase
      role="switch"
      aria-checked={isBuy}
      aria-label={`Direction ${current}, switch to ${other}`}
      disabled={props.disabled}
      onClick={() => setFieldValue("direction", other)}
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        width: DIRECTION_TOGGLE_WIDTH,
        minWidth: DIRECTION_TOGGLE_WIDTH,
        height: SMALL_INPUT_HEIGHT,
        borderRadius: 1,
        overflow: "hidden",
        backgroundColor: grey[500],
        "&.Mui-disabled": {
          opacity: 0.45,
        },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "50%",
          height: "100%",
          borderRadius: 1,
          backgroundColor: activeColor(current),
          transform: isBuy ? "translateX(0)" : "translateX(100%)",
          transition: "transform 160ms ease, background-color 160ms ease",
          "@media (prefers-reduced-motion: reduce)": { transition: "none" },
        }}
      />
      {SIDES.map((side) => (
        <Box
          key={side}
          sx={{
            position: "relative",
            flex: 1,
            textAlign: "center",
            color: "black",
            fontSize: 10,
            fontWeight: 700,
            lineHeight: 1,
            whiteSpace: "nowrap",
          }}
        >
          {side}
        </Box>
      ))}
    </ButtonBase>
  );
};

export { BuySellToggle };
